import { useEffect, useMemo, useState } from "react";
import { setMainLoading, setPageTitle } from "../../../Store/reducers/Common";
import { useDispatch, useSelector } from "react-redux";
import { PostAxios, responseCatchFunc } from "../../../Services/RequestService";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { setToastData } from "../../../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../../../Services/Common";

const SectorMaster = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    //const [currentPage, setCurrentPage] = useState(1);
    const [openAddForm, setOpenAddForm] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [sectorList, setSectorList] = useState([]);
    const BlankDivData = {
        org_id: parseInt(userData.org_id) > 0 ? parseInt(userData.org_id) : 0,
        div_id: '',
        sector_name: ''
    }
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
    });
    const [divData, setDivData] = useState(BlankDivData);
    const [isEditing, setIsEditing] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    useEffect(() => {
        dispatch(setPageTitle(`Sector Master`));
        dispatch(setMainLoading(true));
        Promise.all([PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken),
        PostAxios(`masters/division-list`, { org_id: 0, page: 1, perPage: 1000 }, accessToken)])
            .then((response) => {
                let orgList = response[0].data;
                let divList = response[1].data;
                if (orgList.status === '1') {
                    setOrgList(orgList.data);
                }
                if (divList.status === "1") {
                    setDivList(divList.data);
                }
                else {
                    setDivList([]);
                }
            }).catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
                fetchSectorList();
            });
    }, [accessToken, dispatch])
    const setEditSector = (item) => {
        setDivData({
            org_id: item.sector_org,
            div_id: item.sector_div,
            sector_id: item.id,
            sector_name: item.sector_name
        });
        setOpenAddForm(true);
        setIsEditing(true);
    }
    const fetchSectorList = async () => {
        dispatch(setMainLoading(true));
        PostAxios(`masters/sector-list`, { org_id: 0, page: 1, perPage: 1000 }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setSectorList(data.data);
                }
                else {
                    setSectorList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            });
    }
    return (
        <>
            <div className="main-form-sec">
                <div className="top-right-btn p-0">
                    <button className="btn-blue btn br-0" onClick={() => {
                        setOpenAddForm(!openAddForm);
                        setIsEditing(false);
                        setDivData(BlankDivData);
                    }}>
                        {openAddForm ? 'Close' : (isEditing) ? 'Update Division' : 'Add New'}
                    </button>
                </div>
                <div className={`main-form-sec add-form my-3 ${openAddForm ? 'active-open' : ''}`}>
                    <h4>{openAddForm ? 'Close' : (isEditing) ? 'Update' : 'Add New'} Division</h4>
                    <Formik
                        initialValues={divData}
                        validate={values => {
                            const errors = {};
                            if (!values.org_id && values.org_id === 0) { errors.org_id = 'This field is required'; }
                            if (!values.div_id) { errors.div_id = 'This field is required'; }
                            if (!values.sector_name) { errors.sector_name = 'This field is required'; }
                            return errors
                        }}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            dispatch(setMainLoading(true));
                            setSubmitting(true);
                            let endpoint = `masters/add-sector`;
                            let postData = {
                                org_id: values.org_id,
                                div_id: values.div_id,
                                sector_id: values.sector_id,
                                sector_name: values.sector_name,
                            }
                            if (isEditing > 0) {
                                endpoint = `masters/update-sector`;
                                postData.sector_id = divData.sector_id
                            }
                            PostAxios(endpoint, postData, accessToken).then(({ data }) => {
                                if (data.status === "1") {
                                    dispatch(setToastData({ message: `${data.message}`, isHtml: true, type: 'success', showCloseBtn: true }));
                                    fetchSectorList();
                                    setDivData(BlankDivData)
                                    setIsEditing(false);
                                    resetForm();
                                }
                                else {
                                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))

                                }
                            })
                                .catch(err => {
                                    responseCatchFunc(dispatch, err);
                                }).finally(() => {
                                    dispatch(setMainLoading(false));
                                    setSubmitting(false);
                                });
                        }}
                        enableReinitialize
                    >
                        {({ values, errors, touched, isSubmitting }) => (
                            <Form>
                                <div className="form-sec mt-3">
                                    {
                                        userData.role_slug === "super_admin" &&
                                        <div className={`form-field-group w-25 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                            <div className="w-50">
                                                <label htmlFor="org_id">Organization</label>
                                            </div>
                                            <div className="w-50 input-area">
                                                <Field as="select" className="select-input" id="org_id" name='org_id'>
                                                    <option value="0">Choose Organisation</option>
                                                    {
                                                        orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                                    }
                                                </Field>
                                                <ErrorMessage component="span" name="org_id" className="error-label" />
                                            </div>
                                        </div>
                                    }
                                    <div className={`form-field-group w-25 ${(errors.div_id && touched.div_id) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="div_id">Division</label>
                                        </div>
                                        <div className="w-50 input-area">
                                            <Field as="select" className="form-input" id="div_id" placeholder="Division" name='div_id'>
                                                <option value="0">Choose Division</option>
                                                {
                                                    divList.map((item, index) => {
                                                        if (item.org_id === values.org_id) {
                                                            return <option key={`div-${index}`} value={item.ID}>{item.division_name}</option>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Field>
                                            <ErrorMessage component="span" name="div_id" className="error-label" />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-25 ${(errors.sector_name && touched.sector_name) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="sector_name">Sector Name</label>
                                        </div>
                                        <div className="w-50 input-area">
                                            <Field type="text" className="form-input" id="sector_name" placeholder="Sector Name" name='sector_name' step="1" />
                                            <ErrorMessage component="span" name="sector_name" className="error-label" />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-25`}>
                                        <button type="submit" className="btn btn-blue" disabled={isSubmitting}>Submit</button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="top-reports-filter">
                    <div className={`right-filter-sec`}>
                        <button className="filter-toggle" onClick={() => {
                            setShowFilter(!showFilter);
                        }}>
                            <i className="fa-solid fa-filter"></i>
                        </button>
                        <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => setFilter({ "org_id": e.target.value })}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-filter-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                            <button type="button" className="btn btn-blue ms-2" onClick={() => { fetchSectorList(); }}>Submit</button>
                        </div>
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Division Name</th>
                                <th>Sector Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sectorList.length > 0 && sectorList.map((item, index) => (
                                    <tr key={`org-id-${index}-${item.ID}`}>
                                        <td>{index + 1}</td>
                                        <td>{item.division_name}{`(${item.division_number})`}</td>
                                        <td>{item.sector_name}</td>
                                        <td>
                                            <button className="btn-blue btn btn-sm" onClick={() => { setEditSector(item) }}>
                                                <i className="fa-solid fa-pen"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                            {
                                sectorList.length === 0 && <tr><td colSpan="4">No records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default SectorMaster;